<template>
  <div class="preview-pdf">
    <div class="pdf_box" :style="{width:pdfWidth}" v-loading="isLoading" element-loading-text="加载中...">
      <canvas
        v-for="page in pdfPages"
        :key="page"
        :id="'pdfCanvas' + page"
      ></canvas>
    </div>
  </div>
</template>
<script>
const PDFJS = require('pdfjs-dist')

PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry')

export default {
  name: 'PdfPreview',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pdfPages: [], // 页数
      pdfWidth: '', // 宽度
      pdfSrc: '', // 地址
      pdfDoc: '', // 文档内容
      pdfScale: 1.5, // 放大倍数
      pageNumPending: null, // 待处理页码
      pageRendering: false, // 是否正在渲染
      isLoading: false,
    }
  },
  mounted() {
  },
  watch: {
    pageRendering(newVal) {
      // console.log({ newVal })
      this.isLoading = newVal
    },
    url: {
      handler() {
        this.getPDFUrl()
      },
      immediate: true,
    },
  },
  methods: {
    getPDFUrl() {
      this.pdfPages = []
      // todo 请求后台，获取pdf的url，这里用的是线上的地址
      this.pdfSrc = this.url
      this.loadFile(this.pdfSrc)
    },
    loadFile(url) {
      const loadingTask = PDFJS.getDocument(url)
      this.pageRendering = true
      loadingTask.promise.then((pdf) => {
        this.pdfDoc = pdf
        this.pdfPages = pdf.numPages
        this.$nextTick(() => {
          this.renderPage(1)
        })
      })
    },
    renderPage(num) {
      const that = this
      this.pdfDoc.getPage(num).then((page) => {
        const canvas = document.getElementById(`pdfCanvas${num}`)
        const ctx = canvas.getContext('2d')
        const dpr = window.devicePixelRatio || 1
        const bsr =
          ctx.webkitBackingStorePixelRatio ||
          ctx.mozBackingStorePixelRatio ||
          ctx.msBackingStorePixelRatio ||
          ctx.oBackingStorePixelRatio ||
          ctx.backingStorePixelRatio ||
          1
        const ratio = dpr / bsr
        const viewport = page.getViewport({ scale: this.pdfScale })
        canvas.width = viewport.width * ratio
        canvas.height = viewport.height * ratio

        canvas.style.width = `${viewport.width}px`

        that.pdfWidth = `${viewport.width}px`

        canvas.style.height = `${viewport.height}px`

        ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
        // 将 PDF 页面渲染到 canvas 上下文中
        const renderContext = {
          canvasContext: ctx,
          viewport,
        }
        const renderTask = page.render(renderContext)
        renderTask.promise.then(() => {
          this.pageRendering = false
          if (this.pdfPages > num) {
            this.renderPage(num + 1)
            return
          }
          this.pageNumPending = null
        })
      })
    },
  },
}
</script>
<style lang="scss">
.preview-pdf {
  h1 {
    margin: 30px auto;
    text-align: center;
    font-family: "宋体";
    letter-spacing: 2px;
  }
}
.pdf_box{
  margin:0 auto;
  min-height: 300px;
}
</style>
